/* eslint-disable no-unused-vars */
import {LoginButton, LoginButtonNew, GuestButton} from "../../atoms/Buttons";
import { LoginWrapper } from "../../atoms/Layout";
import { GetHelpLink } from "../../atoms/TextLink";
import { useTranslation } from "react-i18next";
import { useEffect, useState} from "react";
import {useSelector,useDispatch } from "react-redux";
import * as PersistItemsAction from "@mywvglobal-shared/mywv-shared/action/persistItemsAction";
import { constants } from "../../../constants";
import {Div} from "../../atoms/Div";
import { Link, useSearchParams } from "react-router-dom";
import GetHelpIcon from "../../../images/get_help_header.svg";
import CookiesPopup from "../../atoms/CookiesPopup";
import { CenteredText } from "../../atoms/Common";
import { LoginLinkContainer } from "../../atoms/Widget";
import ExternalLink from "../../organism/ExternalLink";
import SponsorNewChildPopup from "../SponsorNewChildPopup";
import { gaEvent } from "../../../utilities/analytics.js";
import SignUpForm from "../../molecule/SignUpForm";
import { WelcomeText  } from "../../atoms/Common";
import { BackButton } from "../../atoms/Header";
import WVFranceLogo from "../../../images/wvlogoheader_login_fr.png";
import WVLogoWHRR from "../../../images/wv-logo-nz.svg";
import WVLogoFin from "../../../images/wv_logo_fino.svg";
import WVLogoJPNO from "../../../images/WorldVision-Logo-Japan.svg";
import { ExecuteSignIn } from "../../../utilities/authUtilities";
import { getCookie } from "../../../utilities/cookieUtilities.js";

const LoginForm = (props) => {
  const { t } = useTranslation();
  let soDetails = props?.soDetails;
  const { loginReducer } = useSelector((state) => state);
  const { persistItemsReducer } = useSelector((state) => state);
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [cookieSettings, setCookieSettings] = useState(false);
  const [guestClick, setguestClick] = useState(false);
  const [guestLink, setguestLink] = useState("");
  const [registerClick, setRegisterClick] = useState(false);
  const [signUpData, setSignUpData] = useState(undefined);
  const [redirectionObj, setRedirectionObj] = useState({});

  const handleLogo = (event) => {
    event.preventDefault();
    gaEvent("WVLogoBtn",persistItemsReducer);
  }
  const handleGetHelp = (event) => {
    event.preventDefault();
    gaEvent("GetHelp",persistItemsReducer);
  }

  const executeSignIn = async () => {
    gaEvent("loginBtn",persistItemsReducer);
    //loginWithRedirect();
      const savedCountryList = persistItemsReducer?.loggedInCountryHistoryList || [];
      if (
        savedCountryList
        && savedCountryList.length
          < loginReducer?.getSOConfiguration?.countryHistoryCount
        && !savedCountryList?.some(
          (country) => country.soLanguageCultureCode === soDetails?.soLanguageCultureCode,
        )
      ) {
        savedCountryList.push(soDetails);
      } else if (
        savedCountryList
        && savedCountryList.length
          >= loginReducer?.getSOConfiguration?.countryHistoryCount
        && !savedCountryList?.some(
          (country) => country.soLanguageCultureCode === soDetails?.soLanguageCultureCode,
        )
      ) {
        savedCountryList.shift();
        savedCountryList.push(soDetails);
      } else if (savedCountryList && savedCountryList.length === 0) {
        savedCountryList.push(soDetails);
      }
      savedCountryList?.reverse();
      const selectedSOData = {
        soCode: soDetails?.soCode,
        languageCode: soDetails?.soLanguageCode,
        soFlag: soDetails?.soFlag,
        soName: soDetails?.soName,
        soLanguageCultureCode: soDetails?.soLanguageCultureCode,
        shortLanguageCode: soDetails?.shortLanguageCode,
      };
      const values = await ExecuteSignIn(loginReducer?.getSOConfiguration?.loginModule);
      const {authState,callback} = values;
      const redirect_url=searchParams.get("redirect_url");
      const param = {
        accessToken : "",
        refreshToken: "" ,
        sponsorID : "",
        isSponsor: true,
        selectedSOData,
        savedCountryList,
        webGlobalPowerClaims:loginReducer?.getSOConfiguration?.webGlobalPowerClaims,
        globalPowerClaimMessageDetails:
          loginReducer?.getSOConfiguration?.globalPowerClaimMessageDetails,
          saveAuthParams: {...authState,id_token:localStorage.getItem("id_token"),navURL:redirect_url},
      }
    dispatch(PersistItemsAction.loginPersist(param));     
    callback && callback();
    localStorage.setItem("userLogging", true)
   }
   const executeGuestClick = () => {
    gaEvent("ContinueAsGuestBtn",persistItemsReducer);
    constants?.guestRedirection.map((list)=>{
      if(soDetails.soName == list.name){
        setguestLink(list.value);
        setguestClick(!guestClick);
      }
    })             
   };
   const executeRegisterClick = () =>{
    setRegisterClick(!registerClick);
    onSignUpClick();
   }
   const onBackHandler=()=>{
    setRegisterClick(!registerClick);
   }
   // SignUp Click
  const onSignUpClick = () => {
    if (
      loginReducer?.getSOConfiguration?.signUpFormSettings
        ?.isInAppRegistrationEnabled
    ) {
      setSignUpData({
        signUpFormSettings: loginReducer?.getSOConfiguration?.signUpFormSettings,
        baseURL: loginReducer?.getSOConfiguration?.soBaseUrl,
        soCode: soDetails?.soCode,
        languageCode: soDetails?.soLanguageCode,
        phoneNumber: loginReducer?.getSOConfiguration?.phoneNumber,
      })
      //setIsLogin(!isLogin);
    } else {
      const url = loginReducer?.getSOConfiguration?.registerationURL;
      window.open(url, "_self")
    }
  };

   useEffect(()=>{
    localStorage.setItem("LoadingYourAccountNZ", "Loading your account details…")
    localStorage.setItem("LoadingYourAccountAUTO", "Deine Portaldaten werden geladen...")
    localStorage.setItem("LoadingYourAccountFINO", "Ladataan käyttäjätietojasi…")
    localStorage.setItem("LoadingYourAccountJPNO", "アカウント情報を読み込み中…")
    localStorage.setItem("LoggingYouFINO", "Kirjaudutaan sisään…")
    localStorage.setItem("LoggingYouAUTO", "Du wirst eingeloggt...")
    localStorage.setItem("LoggingYouJPNO", "ログイン中…")
   },[])

   useEffect(() => {
    props?.setSoDetails(soDetails);
    setRedirectionObj(constants?.guestRedirection?.find((list)=> soDetails?.soName == list?.name))
  }, [soDetails])

  const handleCookieSettings = ()=>{
    setCookieSettings(!cookieSettings);
    gaEvent("CookieSettingsSubmit",persistItemsReducer);
  }

   useEffect(() => {
      if (constants?.so_NZLO?.nzSSOCookieName) {
      // if (document?.referrer && document?.referrer?.includes(".worldvision.org.nz")) {
        console.log("refer", document?.referrer)
        const nz_sso_cookie = getCookie(constants?.so_NZLO?.nzSSOCookieName);
        nz_sso_cookie && nz_sso_cookie !== "" && 
        executeSignIn();
      }
    },[constants?.so_NZLO?.nzSSOCookieName])
  

  return(
    <>
      <LoginWrapper>
      
            {registerClick && persistItemsReducer?.selectedSOData?.soCode != "NZLO" ? (
                <BackButton registerBack onClick={()=>onBackHandler()}>
                <span> {t("DT_WVM_CFIG_HEAD_00004_Back")}</span>
            </BackButton>
            ) : null}

           <CenteredText logo onClick={handleLogo}>
          <Div logo>
          <img
          className="logo"
          src={
            soDetails?.soCode === "FRAO" ? WVFranceLogo :
            soDetails?.soCode === "FINO" ? WVLogoFin :
            soDetails?.soCode === "NZLO" ? WVLogoWHRR :
            soDetails?.soCode === "JPNO" ? WVLogoJPNO :
            WVLogoWHRR
          }
          alt="world vision logo"
        />

          </Div>
        </CenteredText>

         {registerClick ? null : <WelcomeText>{t("WelcomeText")}</WelcomeText>}
        {registerClick ? null :<>
        <CenteredText>       
           {persistItemsReducer?.selectedSOData?.soCode != "NZLO" ? (
            <LoginButtonNew onClick={() => executeSignIn()}><span>{t("LoginText")}</span></LoginButtonNew> 
           ):(<LoginButton onClick={() => executeSignIn()}><span>{t("LoginText")}</span></LoginButton>) } 
        </CenteredText>
           <LoginLinkContainer>
            {loginReducer?.getSOConfiguration?.forgotPassword &&  persistItemsReducer?.selectedSOData?.soCode != "NZLO" &&
            <ExternalLink type="forgotpassword" newTab={true} href={loginReducer?.getSOConfiguration?.forgotPassword} title={t("DT_WVM_LOG_HEAD_00009_ForgPass")}>{t("DT_WVM_LOG_HEAD_00009_ForgPass")}</ExternalLink>}
          </LoginLinkContainer>
          <CenteredText>
            { persistItemsReducer?.selectedSOData?.soCode != "NZLO" && (
                <GuestButton onClick={()=> executeRegisterClick()}>
                  <span>{t("RegisterButton")}</span>
                </GuestButton>
            )}
           </CenteredText>
           </>}
           {registerClick ? <SignUpForm executeSignIn={()=>executeSignIn} signUpData={signUpData} /> : null}

           <LoginLinkContainer help_support> 
            <GetHelpLink onClick={(e)=> handleGetHelp(e)}>
              <Link to={"/gethelp"}>
              <img src={GetHelpIcon} alt="GetHelp"/><span>{t("GetHelp")}</span>
              </Link>
            </GetHelpLink>
            {/* <GetHelpLink><img src={GetHelpIcon} alt="GetHelp"/><span>{t("GetHelp")}</span></GetHelpLink> */}
            <ExternalLink type="privacypolicy" href={loginReducer?.getSOConfiguration?.privacyStatementLink}><span>{t("PrivacyPolicy")}</span></ExternalLink>
            </LoginLinkContainer>
          {/* <br/>
          <CookieSettings onClick={() => handleCookieSettings()}><span>{t("Cookie Settings")}</span></CookieSettings> */}
       
      </LoginWrapper>   
      {cookieSettings &&
              <CookiesPopup
                show={cookieSettings}
                closeBtnClick={handleCookieSettings}
                loginPage
              />
        }
      {guestClick && 
                <SponsorNewChildPopup
                    show={guestClick}
                    closeBtnClick={()=>setguestClick(!guestClick)}
                    TitleText={t("DT_WVM_ACC_HEAD_00078_ContGues")}
                    selectedSOData={persistItemsReducer?.selectedSOData}
                    link={guestLink}
                    />
        }
    </>
  )
}

export default LoginForm;